import ResourceTracking from "./ResourceTracking";

export default ResourceTracking;
